<template>
    <div class="p-4 border border-gray-200 rounded-lg shadow-sm bg-white max-h-[300px] sm:max-h-[400px] md:max-h-[calc(100vh-450px)] overflow-y-auto"> <!-- Adjusted max-h -->
        <h2 class="text-lg sm:text-xl font-semibold mb-3 text-gray-700 sticky top-0 bg-white py-2 z-10 border-b">My Notes</h2>
        <div v-if="files.length === 0" class="text-gray-500 text-center py-4">
            No notes yet. Upload or load notes to get started!
        </div>
        <ul v-else class="space-y-1.5">
            <li v-for="file in files" 
                :key="file.id"
                :class="['flex justify-between items-center p-2.5 rounded-md cursor-pointer transition-all duration-150 ease-in-out group', 
                         file.id === selectedFileId ? 'bg-blue-500 text-white shadow-md ring-2 ring-blue-300' : 'bg-gray-50 hover:bg-blue-100 text-gray-700 hover:shadow-sm']"
                @click="selectFile(file)"
                role="button"
                :aria-pressed="file.id === selectedFileId"
                :aria-label="'Select note ' + file.name"
                tabindex="0"
                @keydown.enter="selectFile(file)"
                @keydown.space="selectFile(file)">
                <span class="truncate pr-2" :title="file.name">{{ file.name }}</span>
                <button @click.stop="deleteNote(file.id)" 
                        class="p-1.5 rounded-full text-gray-400 hover:bg-red-100 hover:text-red-500 opacity-50 group-hover:opacity-100 transition-opacity"
                        aria-label="Delete note"
                        title="Delete note">
                    <svg class="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path></svg>
                </button>
            </li>
        </ul>
    </div>
</template>

<script setup>
defineProps({
  files: { type: Array, required: true },
  selectedFileId: { type: String, default: null }
});

const emit = defineEmits(['file-selected', 'delete-file']);

const selectFile = (file) => {
  emit('file-selected', file);
};

const deleteNote = (fileId) => {
  emit('delete-file', fileId);
};
</script>


<style scoped>
/* Add any component-specific styles here if needed */
.icon {
    width: 1.25em; /* Example size, adjust as needed */
    height: 1.25em;
}
</style>